module.exports = __webpack_public_path__ + "img/blocks.4ce796c.svg";